export const logoNegative = ['690 134',
`<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 543.27 193.82"><defs><style>.cls-1{isolation:isolate;}</style></defs><image class="cls-1" width="2587" height="881" transform="scale(0.21 0.22)" xlink:href="camor%20black%20logo.png"/>
</svg>`]

